<template>
    <el-dialog :visible.sync="visible" :title="'手动移除学生'" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <span style="color: red;font-size: 25px" >本功能仅用于将非正常状态的学生移除出考试的(非管理员请勿操作)</span>
        <el-card shadow="never" class="aui-card--fill">
            <div class="mod-demo__examcourse}">
                <span style="display: inline-block;margin-right: 13px"><el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                    <el-form-item>
                        <el-select v-model="dataForm.gradeId" placeholder="请选择年级" clearable @change="getExamClassListByGradeId()">
                            <el-option
                                    v-for="termList in examGradeList"
                                    :value="termList.gradeId"
                                    :label="termList.gradeName"
                                    :key="termList.gradeId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                </span>
                <span style="display: inline-block;margin-right: 13px"><el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                    <el-form-item>
                        <el-select v-model="dataForm.classId" placeholder="请选择班级" clearable @change="getExamClassStudentByClassId()">
                            <el-option
                                    v-for="termList in examClassList"
                                    :value="termList.classId"
                                    :label="termList.className"
                                    :key="termList.classId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                </span>
                <span style="display: inline-block;margin-right: 13px"><el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                    <el-form-item>
                        <div v-if="allowSubmitVisible">
                        <el-select v-model="dataForm.studentId" placeholder="请选择学生" clearable>
                                <el-option
                                        v-for="termList in examClassStudentList"
                                        :value="termList.studentId"
                                        :label="termList.studentName"
                                        :key="termList.studentId">
                            </el-option>
                        </el-select>
                        </div>
                    </el-form-item>
                </el-form>
                </span>
            </div>
        </el-card>
        <template slot="footer">
            <el-button @click="visible = false">关闭</el-button>
            <el-button v-if="allowSubmitVisible" type="primary" @click="deleteExamStudent()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>

export default {
  data () {
    return {
      visible: false,
      examGradeList: [],
      examClassList: [],
      examClassStudentList: [],
      allowSubmitVisible: false,
      noAllowSubmitVisible: false,
      dataForm: {
        examId: '',
        gradeId: '',
        classId: '',
        studentId: ''
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.getExamGradeList()
      })
    },
    getExamGradeList () {
      this.$http.get('/exam/examGrade/getExamGradeList/' + this.dataForm.examId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.examGradeList = res.data
        console.log('年级', res.data)
        // this.getExamClassListByGradeId()
      })
    },
    getExamClassListByGradeId () {
      this.$http.get('/exam/examClass/getExamClassListByExamGradeId', {
        params: {
          examId: this.dataForm.examId,
          gradeId: this.dataForm.gradeId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.examClassList = res.data
      })
    },
    getExamClassStudentByClassId () {
      console.log(this.dataForm.examId)
      console.log(this.dataForm.classId)
      this.$http.get('/exam/examstudent/getExamStudent/' + this.dataForm.examId + '/' + this.dataForm.classId
      ).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.examClassStudentList = res.data
        if (this.examClassStudentList.length !== 0) {
          this.allowSubmitVisible = true
          this.noAllowSubmitVisible = false
        } else {
          this.noAllowSubmitVisible = true
          this.allowSubmitVisible = false
        }
      })
    },
    deleteExamStudent () {
      this.$confirm(this.$t('prompt.info', { handle: '删除学生' }), '是否确认删除', {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$http.get('/exam/examstudent/deleteLoseExamStudent', {
          params: {
            examId: this.dataForm.examId,
            classId: this.dataForm.classId,
            studentId: this.dataForm.studentId
          }
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.dataForm.examId = ''
              this.dataForm.classId = ''
              this.dataForm.studentId = ''
              this.allowSubmitVisible = false
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        })
      })
    }
  }
}
</script>
